var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaneBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24.0450845px",
    height: "23.2936756px",
    viewBox: "0 0 24.0450845 23.2936756",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C484651-DEF3-4E06-8D3E-3558A57ED8A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transavia",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary",
    transform: "translate(-834.000000, -785.705882)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transavia/Summary/1920",
    transform: "translate(0.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(826.000000, 613.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets/icons/interface/outbound",
    transform: "translate(8.000000, 8.705882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0450845,6.76268003 L22.9532874,6.76268003 L20.2294302,10.2710081 C18.5117095,10.0621165 15.9884784,9.79536631 14.1542893,9.77207264 L16.8999374,-1.77635684e-15 L15.0176581,-1.77635684e-15 L8.84257984,9.76831559 C6.41628053,9.76831559 4.1327489,9.76831559 4.1327489,9.76831559 C1.9018159,9.76831559 0,10.6091421 0,11.6468378 C0,12.6845335 1.87852223,13.5253601 4.1327489,13.5253601 C4.1327489,13.5253601 6.41628053,13.5253601 8.84257984,13.5253601 L15.0176581,23.2936756 L16.8999374,23.2936756 L14.1542893,13.521603 C15.9884784,13.4983093 18.5117095,13.2323106 20.2294302,13.0226675 L22.9532874,16.5309956 L24.0450845,16.5309956 L22.5460238,11.6468378 L24.0450845,6.76268003",
    id: "Icon"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneBack);
export default __webpack_public_path__ + "static/media/plane-back.89a090eef29d37db23a07211759495bb.svg";
export { ForwardRef as ReactComponent };